import React from 'react'
import { Helmet } from "react-helmet-async";
import Footer from "../Components/Footer/footer";
import NewsletterSection from "../Components/Landing/newsletter";
import KryzenHero from '../Components/Landing/hero';
import JobOpenings from '../Components/Landing/job_openings';
import KryzenSocialCard from '../Blog/kryzen_social_media';
import { SharkTankKryzenVideo, GalleryCarouselCard,AgriSubsidyCard,FarmSetupCard,HydroponicWebinarCard, Adcards } from '../Components/Sidebar Banner/sidebarBanner';
import RandomPosts from '../Blog/random_posts';
import LatestPosts from '../Blog/latest_posts';

const Vacancies = () => {
  return (
    <>
    <Helmet>
      <title>
        Kryzen Biotech | India's Leading Hydroponics & Agri-Tech Company |
        Kryzen Info
      </title>
      <meta
        name="description"
        content="Kryzen Biotech provides end-to-end hydroponic farm development, automation, AI-based farm management, and agri training across India."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="hydroponics, hydroponic farming india, smart farming, agri tech, kryzen biotech, greenhouse, farm automation, hydroponic setup"
      />

      {/* Canonical */}
      <link rel="canonical" href="https://kryzen.com/" />

      {/* Open Graph for Social Share */}
      <meta
        property="og:title"
        content="Kryzen Biotech - Smart & Sustainable Farming"
      />
      <meta
        property="og:description"
        content="Leading hydroponics & agri-tech solutions in India."
      />
      <meta property="og:image" content="https://kryzen.com/og-image.jpg" />
      <meta property="og:url" content="https://kryzen.com" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>

    <div className="page-wrapper container">
    <KryzenHero
  title="Join India’s Fastest-Growing Hydroponics & Agri-Tech Team"
  subtitle="At Kryzen Biotech, we are building the future of sustainable farming. Explore exciting career opportunities in engineering, automation, R&D, marketing, sales, and operations — and be part of a mission that transforms agriculture across India."
  buttonText="Send Your Resume"
  buttonLink="https://alpha.kryzen.com/career?theme=light"
  background="bg-light"
/>

      <div className="row ">
        <div className="col-12 col-md-8 col-lg-8 border-0 border-md-end border-md-1 border-dark">
<JobOpenings />
        </div>
        <div className="col-12 col-md-4 col-lg-4 mt-4 mt-md-0 mt-lg-0  sidebar px-4 px-md-0 px-lg-0" >
           <Adcards />
            <div>
           <h2 className="mt-4 fs-1">Trending Articles</h2>
      
      <RandomPosts /> 
           </div>
            <div>
               <KryzenSocialCard />
            </div>
          <div>

            <SharkTankKryzenVideo />
          </div>

          {/* <div>
            <GalleryCard />
          </div> */}
          <div>
<GalleryCarouselCard />

          </div>
           
            
           
           <div className="mt-2">
           <AgriSubsidyCard /> 

           </div>
           <div>
             <HydroponicWebinarCard /> 
           </div>
           <div>
            <FarmSetupCard />
           </div>
          </div>
      </div>

      <LatestPosts />
      <NewsletterSection />
      <Footer />
    </div>
  </>
  )
}

export default Vacancies